export { ApartmentCardSingle } from "./apartment-card-single.component";
export { ApartmentCardMultiple } from "./apartment-card-multiple.component";
export type {
  ApartmentRef,
  ApartmentHighlightRef,
  ApartmentTagRef,
} from "./apartment-card.types";
